import { render, staticRenderFns } from "./UcInflationIndexedSign.yaml?vue&type=template&id=363e443a&component"
import script from "./UcInflationIndexedSign.yaml?vue&type=script&lang=ts&component"
export * from "./UcInflationIndexedSign.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports